import React from 'react';
export const AddTrip = React.lazy(() => import('./AddTrip'));